import { Box, Checkbox, FormControl, FormControlLabel, Typography } from "@mui/material";
import { availableLabelStyle, shiftCardLabelStyle, shiftCardWrapperStyle } from "../styled";

export interface IShiftCardProps {
  checked: boolean,
  onCheck: (e: React.ChangeEvent<HTMLInputElement>) => void,
  description: string,
  isAvailable: boolean,
}

export const ShiftCard = ({ checked, onCheck, description, isAvailable }: IShiftCardProps) => (
  <Box sx={shiftCardWrapperStyle}>
    <FormControl sx={{ display: 'block' }}>
      <FormControlLabel
        value={description}
        sx={shiftCardLabelStyle}
        control={<Checkbox checked={checked} onChange={(e) => onCheck(e)} />}
        label={description}
      />
    </FormControl>
    <Typography className={isAvailable ? 'available' : ''} sx={availableLabelStyle}>
      {isAvailable ? 'AVAILABLE' : 'NOT AVAILABLE'}
    </Typography>
  </Box>
)